import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import AppAdSellersFilter from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppAdSellersFilter/AppAdSellersFilter";
import AppAdSellersFilterResult from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppAdSellersFilter/AppAdSellersFilterResult";
import FindAppsAdsSellersFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/AdsSellersFilter/AdsSellersFilter";
import type { AppsAdsSellersFilterDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsCommonFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";

function createAdsSellersFilter(
    description: AppsAdsSellersFilterDescriptionDto,
): IFilterInstance<IAppsCommonFiltersDto> {
    return {
        key: "adsSellers",
        trackingName: "App Ads Sellers",
        title: { key: "si.find_apps.filters.ads_sellers.title" },
        tooltipText: { key: "si.find_apps.filters.ads_sellers.tooltip" },
        filter: new FindAppsAdsSellersFilter({
            options: description,
        }),
        filterView: AppAdSellersFilter,
        filterResultView: AppAdSellersFilterResult,
    };
}

export default createAdsSellersFilter;
